import React, { Component } from 'react';
import './Questions.css';
import { NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom'

class Questions extends Component {

    constructor(props){
        super(props);
    }

    componentDidMount() {
        document.title = 'Have Questions';
    }

    render () {
          return (
            <div>
              <div> 
                    <NavLink style={{position:'fixed', fontSize:'30px', padding:'15px 30px', color:'white', width:'100%', background: '#333F50'}} tag={Link} to={'/login'}>
                                                swipequotes
                                                </NavLink>
                </div>
            <div className="questionsContainer">
            <div className="questionsHeader"> Have Questions ?</div>
            <p>
              Get answers to some common questions.<br></br><br></br>
              <div className='questionsSubHeader'>What is SwipeQuotes?</div>
              SwipeQuotes is a platform that offers inspirational quotes, life lessons, emotional writings, celebration messages, and curated wisdom — delivered in a swipe-based format.<br></br><br></br>

              <div className='questionsSubHeader'>Is SwipeQuotes free to use?</div>
              Yes, SwipeQuotes offers free access. Some optional premium features may be introduced later.<br></br><br></br>

              <div className='questionsSubHeader'>Do I need to create an account?</div>
              No—basic features can be used without an account. Accounts allow saving favorites, syncing content, and personal collections in future.<br></br><br></br>

              <div className='questionsSubHeader'>Can I submit my own quotes?</div>
              Yes! Selected Users can submit content. Submitted content must follow our Community Guidelines and it will be reviewed accordingly.<br></br><br></br>

              <div className='questionsSubHeader'>Can I share quotes on social media?</div>
              Absolutely. You can share contents in SwipeQuotes with friends, family, and social platforms.<br></br><br></br>

              <div className='questionsSubHeader'>Can I use quotes commercially (books, ads, printing, merch)?</div>
              No, not without written permission. Content is protected under intellectual property laws of respective individuals.<br></br><br></br>

              <div className='questionsSubHeader'>What should I do if I find incorrect or copied content?</div>
              Please report it via email: swipenine@outlook.com<br></br><br></br>

              <div className='questionsSubHeader'>What devices are supported?</div>
              Currently:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Android phones and tablets<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Website accessible on desktop & mobile browsers<br></br>
              Future support: iOS app (coming soon)<br></br><br></br>

              <div className='questionsSubHeader'>Why do I see ads?</div>
              Ads help keep the platform free. Premium plans may offer an ad-free experience later.<br></br><br></br>

              <div className='questionsSubHeader'>How often is content updated?</div>
              New quotes and writings are added daily or weekly depending on submissions and curation.<br></br><br></br>

              <div className='questionsSubHeader'>How do I contact support?</div>
              You can drop in a mail to swipenine@outlook.com<br></br>
              We usually respond in a few hours..<br></br>

            </p>
          </div>
          <div className='questionsFooter'>
                    <Nav horizontal className="list-unstyled pb-3">
                        <NavItem>
                            <NavLink tag={Link} to={'/login'}>
                            Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/aboutUs'}>
                            About Us
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/termsOfService'}>
                            Terms of Service
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/privacyPolicy'}>
                            Privacy & Content Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/questions'}>
                            Have Questions ?
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
          </div>
            
          )
    }
  }
  
  export default Questions